export const FREE_LEAGUES_PER_TOURNAMENT = 4;

export type LeagueLimitInput = {
  isPremium: boolean;
  ownedInTournament: number;
};

/** Non-premium users may own at most 4 leagues per tournament. Joining leagues is unlimited. */
export function canCreateLeague({ isPremium, ownedInTournament }: LeagueLimitInput): boolean {
  if (isPremium) return true;
  return ownedInTournament < FREE_LEAGUES_PER_TOURNAMENT;
}

export function remainingFreeLeagues({ isPremium, ownedInTournament }: LeagueLimitInput): number {
  if (isPremium) return Infinity;
  return Math.max(0, FREE_LEAGUES_PER_TOURNAMENT - ownedInTournament);
}

export function countOwnedLeagues(
  leagues: { owner_id?: string | null; tournament_id?: string | null }[],
  userId: string,
  tournamentId: string | null,
): number {
  if (!tournamentId) return 0;
  return leagues.filter((l) => l.owner_id === userId && l.tournament_id === tournamentId).length;
}

export function isLeagueLimitError(message?: string | null): boolean {
  return !!message && message.includes("LEAGUE_LIMIT_REACHED");
}
